// TODO сделать рефакторинг методов обрабоки баннеров карусели
export var getCurrentViewBanner = function getCurrentViewBanner(_ref) {
  var _banners$currentIndex, _banners$currentIndex2;
  var banners = _ref.banners,
    currentBanner = _ref.currentBanner,
    currentIndex = _ref.currentIndex,
    maxLengthBanners = _ref.maxLengthBanners,
    viewedList = _ref.viewedList;
  if (currentBanner === 0 && !viewedList.includes(maxLengthBanners)) {
    var _banners, _banners2;
    return {
      id: maxLengthBanners,
      link: ((_banners = banners[maxLengthBanners - 1]) === null || _banners === void 0 ? void 0 : _banners.link) || 'pop_up',
      title: (_banners2 = banners[maxLengthBanners - 1]) === null || _banners2 === void 0 ? void 0 : _banners2.title
    };
  }
  if (currentBanner === maxLengthBanners + 1 && !viewedList.includes(1)) {
    var _banners$, _banners$2;
    return {
      id: 1,
      link: ((_banners$ = banners[0]) === null || _banners$ === void 0 ? void 0 : _banners$.link) || 'pop_up',
      title: (_banners$2 = banners[0]) === null || _banners$2 === void 0 ? void 0 : _banners$2.title
    };
  }
  return {
    id: currentBanner,
    link: ((_banners$currentIndex = banners[currentIndex]) === null || _banners$currentIndex === void 0 ? void 0 : _banners$currentIndex.link) || 'pop_up',
    title: (_banners$currentIndex2 = banners[currentIndex]) === null || _banners$currentIndex2 === void 0 ? void 0 : _banners$currentIndex2.title
  };
};
export var getAlreadyIncludes = function getAlreadyIncludes(_ref2) {
  var currentBanner = _ref2.currentBanner,
    maxLengthBanners = _ref2.maxLengthBanners,
    viewedList = _ref2.viewedList;
  return viewedList.includes(currentBanner) || currentBanner === 0 && viewedList.includes(maxLengthBanners) || currentBanner === maxLengthBanners + 1 && viewedList.includes(1);
};